export enum ENTITLEMENT_TYPES {
  all = 0,
  automatic = 17,
  singleUse = 18,
}
